import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Card } from '@angisoft/ui';
import { apiPost, setClientAccessToken } from '@angisoft/api-client';
import { LoadingIndicator, VisualState } from '@angisoft/ui';

export default function ClientPortalAccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      return;
    }
    let mounted = true;
    apiPost<{ accessToken?: string; token?: string; clientToken?: string }>('/client-portal/verify', { token })
      .then((res) => {
        if (!mounted) return;
        const accessToken = res.accessToken ?? res.token ?? res.clientToken ?? '';
        setClientAccessToken(accessToken);
        setStatus('success');
        setTimeout(() => {
          if (mounted) navigate('/portal', { replace: true });
        }, 600);
      })
      .catch(() => {
        if (!mounted) return;
        setStatus('error');
      });
    return () => {
      mounted = false;
    };
  }, [searchParams, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--bg-primary)] px-4">
      <Card className="w-full max-w-md p-8 text-center">
        {status === 'verifying' ? (
          <LoadingIndicator variant="orbit" size="lg" />
        ) : null}
        {status === 'success' ? (
          <>
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500/10 text-2xl text-emerald-400">
              ✓
            </div>
            <h1 className="mt-5 text-2xl font-bold text-[var(--text-primary)]">Access granted</h1>
            <p className="mt-3 text-sm text-[var(--text-muted)]">Taking you to your dashboard…</p>
          </>
        ) : null}
        {status === 'error' ? (
          <>
            <VisualState variant="error" />
            <div className="mt-8 flex flex-col gap-3">
              <Link to="/portal/request" className="w-full">
                <Button className="w-full">Request a new link</Button>
              </Link>
              <Link to="/" className="text-sm font-medium text-[#0875FF] hover:underline">
                Back to home
              </Link>
            </div>
          </>
        ) : null}
      </Card>
    </div>
  );
}
